






import Vue from 'vue'
import { LayoutBox } from '@/types/layouts'
import { AssetType } from '@/types/assets'
import { KeyDict } from '@/types'

export default Vue.extend({
  props: {
    boxes: {
      type: Object as () => KeyDict<LayoutBox>,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    }
  },
  computed: {
    layoutstyle (): Partial<CSSStyleDeclaration> {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        backgroundColor: 'gray',
        position: 'relative',
        borderWidth: '2px',
        borderColor: 'azure',
        borderStyle: 'ridge'
      }
    }
  },
  methods: {
    boxStyle (box: LayoutBox): Partial<CSSStyleDeclaration> {
      const minimalPreviewSize = 8 // make sure smallest box sizes are still visible on preview
      const previewWidth = Math.max(box.width / 1920 * parseInt(this.width), minimalPreviewSize)
      const previewHeight = Math.max(box.height / 1080 * parseInt(this.height), minimalPreviewSize)
      const style: Partial<CSSStyleDeclaration> = {
        // the magical -4 number is used for the layout list page (small preview)
        width: (previewWidth - 4) + 'px',
        height: (previewHeight - 4) + 'px',
        left: (box.left / 1920 * parseInt(this.width)) + 'px',
        top: (box.top / 1080 * parseInt(this.height)) + 'px',
        zIndex: '' + box.zindex,
        backgroundColor: this.boxColor(box),
        position: 'absolute',
        opacity: '' + (+!box.invisible)
      }
      return style
    },
    boxColor (box: LayoutBox): string {
      // note: some types are hidden from preview (eg graphics)
      if (box.type === 'container' || box.types === undefined) {
        return 'rgba(252, 0, 0, 0.5)'
      } else if (box.types.includes(AssetType.Caster)) {
        return 'rgba(252, 255, 252, 0.8)'
      } else if (box.types.includes(AssetType.Broadcast)) {
        return 'rgba(43, 43, 43, 0.8)'
      } else if (box.types.includes(AssetType.Tweet)) {
        return 'rgba(0, 132, 180, 0.8)'
      } else if (box.types.includes(AssetType.Instagram)) {
        return 'rgba(245, 28, 9, 0.4)'
      } else if (box.types.includes(AssetType.SimpleCG)) {
        return 'rgba(255, 190, 0, 0.5)'
      } else if (box.types.includes(AssetType.Widget) || box.types.includes(AssetType.Chat) || box.types.includes(AssetType.YouTubeChat)) {
        return 'rgba(101,185,240,0.4)'
      } else {
        return 'rgba(11, 51, 22, 0)'
      }
    }
  }
})
